import { lazy } from 'react'

export const routes = {
  login: {
    path: '/',
    component: lazy(() => import('./pages/Loginpage/Loginpage')),
    exact: true,
    private: false,
    permission: false,
    generateRoute: () => {
      return '/'
    },
  },

  signup: {
    path: '/signup',
    component: lazy(() => import('./pages/Signuppage/Signuppage')),
    exact: true,
    private: false,
    permission: false,
  },
  forgotpasswordrequest: {
    path: '/forgotpasswordrequest',
    component: lazy(() =>
      import('./pages/Forgotpasswordpage/Forgotpasswordpage')
    ),
    exact: true,
    private: false,
    permission: false,
    generateRoute: () => {
      return '/forgotpasswordrequest'
    },
  },
  changepassword: {
    path: '/changepassword',
    component: lazy(() =>
      import('./pages/Createaccountpage/Createaccountpage')
    ),
    exact: true,
    private: true,
    permission: false,
    generateRoute: () => {
      return '/changepassword'
    },
  },

  forgotpassword: {
    path: '/forgotpassword/:token',
    component: lazy(() =>
      import('./pages/Createaccountpage/Createaccountpage')
    ),
    exact: true,
    private: false,
    permission: false,
    generateRoute: () => {
      return '/forgotpassword'
    },
  },

  customers: {
    path: '/customers',
    component: lazy(() =>
      import('./pages/Customerslistpage/Customerslistpage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/customers'
    },
  },
  customersattachments: {
    path: '/customer/:id/attachments',
    component: lazy(() =>
      import('./pages/Customersattachmentspage/Customersattachmentspage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (id) => {
      return `/customer/${id}/attachments`
    },
  },
  customerdetail: {
    path: '/customer/:id',
    component: lazy(() =>
      import('./pages/Customerdetailpage/Customerdetailpage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (id, state) => {
      if (state) {
        return `/customer/${id}?state=${state}`
      } else {
        return `/customer/${id}`
      }
    },
  },
  projects: {
    path: '/projects',
    pathName: 'projects',
    component: lazy(() => import('./pages/Projectslistpage/Projectslistpage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return `/projects`
    },
  },
  projectdetail: {
    path: '/project/:id',
    pathName: 'projectdetail',
    component: lazy(() =>
      import('./pages/Projectdashboardpage/Projectdashboardpage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (id, state) => {
      if (state) {
        return `/project/${id}?state=${state}`
      } else {
        return `/project/${id}`
      }
    },
  },
  projectteam: {
    path: '/project/:id/team',
    pathName: 'projectteam',
    component: lazy(() => import('./pages/Projectteampage/Projectteampage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (id, state) => {
      if (state) {
        return `/project/${id}/team?state=${state}`
      } else {
        return `/project/${id}/team`
      }
    },
  },
  projectspace: {
    path: '/project/:id/spaces',
    component: lazy(() => import('./pages/Spacelistpage/Spacelistpage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (id) => {
      return `/project/${id}/spaces`
    },
  },
  users: {
    path: '/users',
    component: lazy(() => import('./pages/Userlistpage/Userlistpage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/users'
    },
  },
  spacedetail: {
    path: '/project/:id/space/:spaceId/tasklist',
    component: lazy(() => import('./pages/Spacedetailpage/Spacedetailpage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (projectId, spaceId) => {
      return `/project/${projectId}/space/${spaceId}/tasklist`
    },
  },
  taskdetail: {
    path: '/project/:id/space/:spaceId/task/:taskId',
    component: lazy(() => import('./pages/Taskdetailpage/Taskdetailpage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: ({ projectId, spaceId, taskId }) => {
      return `/project/${projectId}/space/${spaceId}/task/${taskId}`
    },
  },
  taskdet: {
    path: '/projects/:id/space/:spaceId/task/:taskId',
    component: lazy(() => import('./pages/Taskdetailpageforalltask/taskdet')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: ({ projectIda, spaceIda, taskIda }) => {
      return `/projects/${projectIda}/space/${spaceIda}/task/${taskIda}`
    },
  },
  comments: {
    path: '/project/:id/comments',
    component: lazy(() =>
      import('./pages/Projectcommentspage/Projectcommentspage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (projectId, state) => {
      if (state) {
        return `/project/${projectId}/comments?state=${state}`
      } else {
        return `/project/${projectId}/comments`
      }
    },
  },
  actionslist: {
    path: '/project/:id/actions',
    component: lazy(() =>
      import('./pages/Projectactionspage/Projectactionspage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (projectId, state) => {
      if (state) {
        return `/project/${projectId}/actions?state=${state}`
      } else {
        return `/project/${projectId}/actions`
      }
    },
  },
  actiondetail: {
    path: '/project/:id/action-item/:actionId',
    component: lazy(() =>
      import('./pages/ActionItemdetailpage/ActionItemdetailpage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (projectId, actionId) => {
      return `/project/${projectId}/action-item/${actionId}`
    },
  },

  projectattachmentsfolders: {
    path: '/project/:id/folder',
    component: lazy(() =>
      import(
        './pages/Projectsattachmentsfolderpage/Projectsattachmentsfolderpage'
      )
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (id) => {
      return `/project/${id}/folder`
    },
  },

  projectattachments: {
    path: '/project/:id/attachments/:a_id',
    component: lazy(() =>
      import('./pages/Projectsattachmentspage/Projectsattachmentspage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (id, a_id) => {
      return `/project/${id}/attachments/${a_id}`
    },
  },

  projectsdailystatusreport: {
    path: '/project/:id/daily-status-report',
    component: lazy(() =>
      import('./pages/Projectsdailystatusreport/Projectsdailystatusreport')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (id) => {
      return `/project/${id}/daily-status-report`
    },
  },

  projectnotes: {
    path: '/project/:id/note',
    component: lazy(() => import('./pages/ProjectNotespage/ProjectNotespage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (id) => {
      return `/project/${id}/note`
    },
  },
  tempspacelistfolder: {
    path: '/template/space-folder',
    component: lazy(() =>
      import('./pages/Tempspacelistfolderpage/Tempspacelistfolderpage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return `/template/space-folder`
    },
  },

  tempspacelist: {
    path: '/template/spacelist',
    component: lazy(() =>
      import('./pages/Tempspacelistpage/Tempspacelistpage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (fName, id) => {
      return `/template/spacelist?fname=${fName}&fId=${id}`
    },
  },

  tempTaskfolder: {
    path: '/template/task-folder',
    component: lazy(() =>
      import('./pages/TempsTaskTemplatefolderpage/TempsTaskTemplatefolderpage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return `/template/task-folder`
    },
  },
  temptasklist: {
    path: '/template/tasklist',
    component: lazy(() => import('./pages/Temptasklistpage/Temptasklistpage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (fName, id) => {
      return `/template/tasklist?fname=${fName}&fId=${id}`
    },
  },
  configrole: {
    path: '/config/role',
    component: lazy(() => import('./pages/Configrolepage/Configrolepage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return `/config/role`
    },
  },

  feedback: {
    path: '/project/:id/internal-feedback',
    component: lazy(() => import('./pages/Feedbackpage/Feedbackpage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (projectId) => {
      return `/project/${projectId}/internal-feedback`
    },
  },
  customerActionitems: {
    path: '/customer/:id/actionitems',
    component: lazy(() =>
      import('./pages/Cusactionitempage/Cusactionitempage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (id) => {
      return `/customer/${id}/actionitems`
    },
  },
  projectalltasks: {
    path: '/project/:id/allTasks',
    component: lazy(() =>
      import('./pages/Projectalltaskspage/Projectalltaskspage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (projectId) => {
      return `/project/${projectId}/allTasks`
    },
  },
  taskgroupfolder: {
    path: '/template/taskgroups-folder', //change config to template
    component: lazy(() =>
      import('./pages/Taskgroupfolderpage/Taskgroupfolderpage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return `/template/taskgroups-folder`
    },
  },
  taskgroup: {
    path: '/template/taskgroups', //change config to template
    component: lazy(() => import('./pages/Taskgrouppage/Taskgrouppage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (fname, fId) => {
      return `/template/taskgroups?fname=${fname}&fId=${fId}`
    },
  },
  reportingfeedback: {
    path: '/reporting/internal-feedback',
    component: lazy(() =>
      import('./pages/ReportingFeedbackPage/ReportingFeedbackPage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/reporting/internal-feedback'
    },
  },
  reportingopenActionItem: {
    path: '/reporting/open/actions',
    component: lazy(() =>
      import('./pages/ReportingOpenActionItemPage/ReportingOpenActionItemPage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/reporting/open/actions'
    },
  },

  reportingnotification: {
    path: '/reporting/notification',
    component: lazy(() =>
      import('./pages/ReportingNotificationPage/ReportingNotificationPage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/reporting/notification'
    },
  },

  reportingtimeline: {
    path: '/reporting/timeline',
    component: lazy(() =>
      import('./pages/Reportingtimelinepage/Reportingtimeline')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/reporting/timeline'
    },
  },

  reportingactionitem: {
    path: '/reporting/actionitem',
    component: lazy(() =>
      import('./pages/Reportingactionitempage/Reportingactionitempage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/reporting/actionitem'
    },
  },

  reportingsync: {
    path: '/reporting/sync',
    component: lazy(() =>
      import('./pages/ReportingSyncPage/ReportingSyncPage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/reporting/sync'
    },
  },

  reportingsProjectLeads: {
    path: '/reporting/leads',
    component: lazy(() =>
      import('./pages/ReportingProjectLeadsPage/ReportingProjectLeadsPage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/reporting/leads'
    },
  },

  reportingsProjectLeadsDetails: {
    path: '/reporting/lead/:id',
    component: lazy(() =>
      import(
        './pages/ReportingProjectLeadsDetails/ReportingProjectLeadsDetails'
      )
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (id) => {
      return `/reporting/lead/${id}`
    },
  },

  faq: {
    path: '/faq',
    component: lazy(() => import('./pages/FaqPage/FaqPage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/faq'
    },
  },
  faqadmin: {
    path: '/faq-admin',
    component: lazy(() => import('./pages/FaqAdminPage/FaqAdminPage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/faq-admin'
    },
  },

  gallery: {
    path: '/project/:id/gallery',
    component: lazy(() =>
      import('./pages/Projectgallerypage/Projectgallerypage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (projectId) => {
      return `/project/${projectId}/gallery`
    },
  },

  myprofile: {
    path: '/myprofile',
    component: lazy(() => import('./pages/Myprofilepage/Myprofilepage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (tab) => {
      return `/myprofile?active=${tab}`
    },
  },
  homeactionitem: {
    path: '/home/overdue/action-items',
    pathName: 'homeactionitem',
    component: lazy(() =>
      import('./pages/HomeOverdueActionspage/HomeOverdueActionspage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/home/overdue/action-items'
    },
  },

  homeProjectsReportReadiness: {
    path: '/home/projects/report-readiness',
    pathName: 'homeProjectsReportReadiness',
    component: lazy(() =>
      import('./pages/HomeProjectsReportReadiness/HomeProjectsReportReadiness')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return `/home/projects/report-readiness`
    },
  },

  dashboardossprojectcomment: {
    path: '/home/projects/oss-comment',
    pathName: 'dashboardossprojectcomment',
    component: lazy(() =>
      import('./pages/DashboardOOSCommentPage/DashboardOOSCommentPage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return `/home/projects/oss-comment`
    },
  },

  dashboardbudgetreportpage: {
    path: '/home/report/budget',
    pathName: 'dashboardbudgetreportpage',
    component: lazy(() =>
      import('./pages/DashboardBudgetReportPage/DashboardBudgetReportPage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return `/home/report/budget`
    },
  },

  dahboardprojects: {
    path: '/home/projects/',
    pathName: 'dahboardprojects',
    component: lazy(() =>
      import('./pages/DashboardProjects/DashboardProjects')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (status, year, month) => {
      if (status && year && month) {
        return `/home/projects?status=${status}&year=${year}&month=${month}`
      } else if (status) {
        return `/home/projects?status=${status}`
      } else {
        return `/home/projects`
      }
    },
  },

  homepage: {
    path: '/home',
    pathName: 'homepage',
    component: lazy(() => import('./pages/Homepage/Homepage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/home'
    },
  },

  resellerhomepage: {
    path: '/reseller/home',
    pathName: 'homepage',
    component: lazy(() => import('./pages/ResellerHome/ResellerHomepage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/reseller/home'
    },
  },

  extrapage: {
    path: '/extra',
    component: lazy(() => import('./pages/Extrapage/Extrapage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/extra'
    },
  },
  assignorg: {
    path: '/assign-organization',
    pathName: 'assign-organization',
    component: lazy(() =>
      import('./pages/AssignOrganizationpage/AssignOrganizationpage')
    ),
    exact: true,
    private: false,
    permission: false,
    hybrid: true,
    generateRoute: () => {
      return '/assign-organization'
    },
  },
  organizationlist: {
    path: '/organization',
    pathName: 'organization',
    component: lazy(() =>
      import('./pages/OrganizationListpage/view/OrganizationListpage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/organization'
    },
  },
  resellerorganizationlist: {
    path: '/reseller/organization',
    pathName: 'organization',
    component: lazy(() =>
      import(
        './pages/ResellerOrganizationlistPage/view/ResellerOrganizationListpage'
      )
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/reseller/organization'
    },
  },
  organizationdetail: {
    path: '/organization/:orgId/customer',
    pathName: 'organizationdetail',
    component: lazy(() =>
      import('./pages/OrganizationCustomerPage/OrganizationCustomerPage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (orgId, name) => {
      return `/organization/${orgId}/customer`
    },
  },
  organizationprojectlist: {
    path: '/organization/:orgId/projects',
    pathName: 'organizationprojectlist',
    component: lazy(() =>
      import('./pages/OrganizationProjectListPage/OrganizationProjectListPage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (orgId) => {
      return `/organization/${orgId}/projects`
    },
  },
  organizationusers: {
    path: '/organization/:orgId/user',
    pathName: 'organizationusers',
    component: lazy(() =>
      import('./pages/OrganizationUsersPage/OrganizationUsersPage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (orgId) => {
      return `/organization/${orgId}/user`
    },
  },
  organizationtemplates: {
    path: '/organization/:orgId/template',
    pathName: 'organizationtemplates',
    component: lazy(() =>
      import('./pages/OrganizationTemplates/OrganizationTemplates')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (orgId) => {
      return `/organization/${orgId}/template`
    },
  },

  organizationtempspacelist: {
    path: '/organization/:orgId/:backTo/spacelist',
    component: lazy(() =>
      import(
        './pages/OrganizationSpaceTempListing/OrganizationSpaceTempListing'
      )
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (orgId, fName, id) => {
      return `/organization/${orgId}/template/spacelist?fname=${fName}&fId=${id}`
    },
  },

  organizationtemptasklist: {
    path: '/organization/:orgId/template/tasklist',
    component: lazy(() =>
      import('./pages/OrganizationTaskTempListing/OrganizationTaskTempListing')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (orgId, fName, id) => {
      return `/organization/${orgId}/template/tasklist?fname=${fName}&fId=${id}`
    },
  },

  organizationconfigrole: {
    path: '/organization/:orgId/roles',
    pathName: 'organizationconfigrole',
    component: lazy(() =>
      import('./pages/OrganizationConfigRole/OrganizationConfigRole')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (orgId) => {
      return `/organization/${orgId}/roles`
    },
  },
  organizationconfigtaskgroup: {
    path: '/organization/:orgId/taskgroup',
    pathName: 'organizationtaskgroup',
    component: lazy(() =>
      import('./pages/OrganizationConfigTaskGroup/OrganizationConfigTaskGroup')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (orgId) => {
      return `/organization/${orgId}/taskgroup`
    },
  },
  organizationconfigtaskgrouplisting: {
    path: '/organization/:orgId/taskgroup/tasklist',
    pathName: 'organizationtaskgroup',
    component: lazy(() =>
      import(
        './pages/OrganizationConfigTaskGroupList/OrganizationConfigTaskGroupList'
      )
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (orgId, fName, id) => {
      return `/organization/${orgId}/taskgroup/tasklist?fname=${fName}&fId=${id}`
    },
  },
  organizationUsage: {
    path: '/organization/:orgId/usage',
    pathName: 'organizationtaskgroup',
    component: lazy(() =>
      import('./pages/OrganizationUsagePage/OrganizationUsagePage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (orgId) => {
      return `/organization/${orgId}/usage`
    },
  },
  organizationalluserlist: {
    path: '/all-users',
    pathName: 'all-users',
    component: lazy(() =>
      import('./pages/OrganizationAllUsers/OrganizationAllUsers')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/all-users'
    },
  },
  organizationPaySubsList: {
    path: '/subscriptionslist',
    pathName: 'subscriptionslist',
    component: lazy(() =>
      import('./pages/Paymentsandsubscriptionpage/Paymentsandsubscriptionpage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/subscriptionslist'
    },
  },
  organizationJobBoardList: {
    path: '/jobboard',
    pathName: 'jobboard',
    component: lazy(() => import('./pages/JobBoard/JobBoardPage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/jobboard'
    },
  },
  emailAcceptance: {
    path: '/accept-invitations/:token',
    pathName: 'accept-invitations',
    component: lazy(() =>
      import('./pages/Emailacceptancepage/Emailacceptancepage')
    ),
    exact: true,
    private: false,
    permission: false,
    generateRoute: () => {
      return '/accept-invitations'
    },
  },

  projectExportAll: {
    path: '/project-exports/:userid/:id',
    pathName: 'project-exports',
    component: lazy(() =>
      import('./pages/ProjectExportAllPage/ProjectExportAllPage')
    ),
    exact: true,
    private: false,
    permission: false,
    generateRoute: () => {
      return '/project-exports'
    },
  },

  subscriptionPlansList: {
    path: '/subscription-plans',
    pathName: 'organizationconfigrole',
    component: lazy(() =>
      import('./pages/SubscriptionPlanPage/SubscriptionPlanPage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return `/subscription-plans`
    },
  },
  termsConditionpage: {
    path: '/termscondition',
    pathName: 'terms-Condition',
    component: lazy(() =>
      import('./pages/Termsconditionpage/Termsconditionpage')
    ),
    exact: true,
    private: false,
    permission: false,
    hybrid: true,
    generateRoute: () => {
      return '/termscondition'
    },
  },

  termsConditionpageforAll: {
    path: '/termsconditions',
    pathName: 'terms-Conditions',
    component: lazy(() =>
      import('./pages/Termsconditionpage/TermsConditionPageforAll')
    ),
    exact: true,
    private: false,
    permission: false,
    hybrid: true,
    generateRoute: () => {
      return '/termsconditions'
    },
  },

  termsConditionpageforReseller: {
    path: '/reseller/termsconditions',
    pathName: 'termsConditions',
    component: lazy(() =>
      import('./pages/Termsconditionpage/TermsConditionPageforAll')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/reseller/termsconditions'
    },
  },

  confirmandpay: {
    id: 'confirmandpay',
    name: 'Confirm Pay',
    path: '/confirmandpay',
    isPrivate: true,
    component: lazy(() =>
      import('./pages/Confirmandpaypage/Confirmandpaypage')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (planId, userCount, orgId, plan) => {
      return `/confirmandpay?planid=${planId}&users=${userCount}&orgid=${orgId}${
        plan ? `&plan=${plan}` : ''
      }`
    },
  },

  docsview: {
    id: 'docview',
    name: 'docview',
    path: '/view',
    component: lazy(() => import('./containers/DocFullView/DocFullView')),
    isPrivate: true,
    exact: true,
    permission: true,
    generateRoute: (url, fileName, ext) => {
      return `/view?file=${url}&filename=${fileName}`
    },
  },
  configbudget: {
    path: '/config/budget',
    component: lazy(() => import('./pages/ConfigBudget/ConfigBudget')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return `/config/budget`
    },
  },

  projectnotedocsview: {
    id: 'docview',
    name: 'docview',
    path: '/viewfile',
    component: lazy(() =>
      import('./containers/DocFullViewforProjectNote/DocFullViewforProjectNote')
    ),
    isPrivate: true,
    exact: true,
    permission: true,
    generateRoute: (url, fileName, ext) => {
      return `/viewfile?file=${url}&filename=${fileName}`
    },
  },

  configtag: {
    path: '/config/tag',
    component: lazy(() => import('./pages/ConfigTag/ConfigTag')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return `/config/tag`
    },
  },
  projectbudget: {
    path: '/project/:id/budget',
    component: lazy(() => import('./pages/ProjectBudget/ProjectBudget')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (projectId) => {
      return `/project/${projectId}/budget`
    },
  },

  dashboardprojectbudget: {
    path: '/project/:id/dashboardbudget',
    component: lazy(() =>
      import('./pages/ProjectBudgetforDashboard/ProjectBudgetforDashboard')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: (projectId) => {
      return `/project/${projectId}/dashboardbudget`
    },
  },

  reportingbudget: {
    path: '/reporting/budget',
    component: lazy(() => import('./pages/ReportBudget/ReportBudget')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/reporting/budget'
    },
  },
  reseller: {
    path: '/reseller',
    component: lazy(() => import('./pages/Reseller/ResellerActive')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/reseller'
    },
  },
  resellerRevenue: {
    path: '/reseller/revenue',
    component: lazy(() => import('./pages/Revenuepage/RevenuePage')),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/reseller/revenue'
    },
  },
  HompageAfterExpirePlan: {
    path: '/homepageexpire',
    component: lazy(() =>
      import('./pages/HompageAfterExpirePlan/HompageAfterExpirePlan')
    ),
    exact: true,
    private: true,
    permission: true,
    generateRoute: () => {
      return '/homepageexpire'
    },
  },
}

export const renderRoutes = Object.entries(routes)
